import { render, staticRenderFns } from "./MobilePageCybo.vue?vue&type=template&id=97a5a100&scoped=true&"
import script from "./MobilePageCybo.vue?vue&type=script&lang=js&"
export * from "./MobilePageCybo.vue?vue&type=script&lang=js&"
import style0 from "./MobilePageCybo.vue?vue&type=style&index=0&id=97a5a100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a5a100",
  null
  
)

export default component.exports